import React from "react";
import Grid from "@mui/material/Unstable_Grid2";
import { Box, Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate, useSearchParams, matchPath } from "react-router-dom";
import VendorActionPanel from "../components/VendorActionPanel";
import VendorServicesList from "../components/VendorServicesList";
import VendorAppDownload from "../components/VendorAppDownload";
import { getCategoryTheme } from "../categoryThemes";
import {
  CountryCode,
  COUNTRIES,
  getCategoryById,
  getListingForVendorInCategory,
  getVendorById,
} from "../mockData/marketplaceMockData";
import "../Marketplace.scss";

const VendorDetailPage: React.FC = () => {
  const location = useLocation();
  const vendorMatch = matchPath(
    "/home-employee/marketplace/vendor/:vendorId",
    location.pathname
  );
  const vendorId = vendorMatch?.params.vendorId || "";
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const categoryId = searchParams.get("category") || "";
  const country = (searchParams.get("country") as CountryCode) || "IN";

  const vendor = getVendorById(vendorId || "");
  const category = getCategoryById(categoryId);
  const listing = getListingForVendorInCategory(categoryId, vendorId || "");
  const countryLabel = COUNTRIES.find((c) => c.code === country)?.label || country;
  const theme = getCategoryTheme(category?.id || "");

  if (!vendor) {
    return (
      <Box className="marketplace_wrapper">
        <p>Vendor not found.</p>
        <Button onClick={() => navigate("/home-employee/marketplace")}>Back to Marketplace</Button>
      </Box>
    );
  }

  const backUrl = category
    ? `/home-employee/marketplace/category/${category.id}?country=${country}`
    : `/home-employee/marketplace?country=${country}`;

  const metaItems = [
    vendor.isPlatformVendor ? "Platform Partner" : null,
    ...(vendor.tags?.filter((tag) => tag !== "Platform Partner").slice(0, 2) || []),
  ].filter(Boolean) as string[];

  return (
    <Box
      className="marketplace_wrapper marketplace_vendor_detail"
      style={
        {
          "--category-accent": theme.accent,
          "--category-accent-soft": theme.accentSoft,
          "--category-gradient": theme.gradient,
        } as React.CSSProperties
      }
    >
      <Grid container spacing={2}>
        <Grid xs={12}>
          <Button className="breadcrumb_back" startIcon={<ArrowBackIcon />} onClick={() => navigate(backUrl)}>
            {category ? `${category.name} · ${countryLabel}` : "Marketplace"}
          </Button>
        </Grid>

        <Grid xs={12} md={8}>
          <Box className="vendor_detail_hero">
            <Box className="vendor_detail_header">
              <img src={vendor.logo} alt={vendor.name} className="vendor_detail_logo" />
              <Box className="vendor_detail_intro">
                <h5>{vendor.name}</h5>
                <p className="vendor_summary">{listing?.highlight || vendor.description}</p>
                {metaItems.length > 0 && (
                  <p className="vendor_meta_line">{metaItems.join(" · ")}</p>
                )}
              </Box>
            </Box>
          </Box>

          <VendorServicesList services={vendor.services} about={vendor.longDescription} country={country} />
        </Grid>

        <Grid xs={12} md={4}>
          <Box className="vendor_detail_sidebar">
            <Box className="vendor_detail_action_card">
              <h6>Get started</h6>
              <VendorActionPanel vendor={vendor} />
            </Box>

            {vendor.appDownload && (
              <Box className="vendor_detail_action_card app_download_card">
                <VendorAppDownload vendorName={vendor.name} appDownload={vendor.appDownload} />
              </Box>
            )}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default VendorDetailPage;
